// react-i18next から useTranslation フックをインポート
import { useTranslation } from 'react-i18next';
import { HeaderBreadcrumbsProps } from 'src/components/HeaderBreadcrumbs';
import { PageLayout } from 'src/components/app-components/PageLayout';
// カレンダー管理画面上部に表示されるボタン群を管理するコンポーネントをインポート
import { CalendarButtonGroup } from '../components/CalendarButtonGroup';
// カレンダー管理画面上部の画面項目やボタンを表示するためのコンポーネントをインポート
import { CalendarListPageCommonGrid } from '../components/CalendarListPageCommonGrid';
// カレンダー一覧をインポート
import { CalendarListGrid } from './list/CalendarListGrid';

export const CalendarListPage = () => {
  const { t } = useTranslation();
  const enqueteCalendarListTitle = t('enqueteCalendarList.pageTitle');
  const breadcrumbs: HeaderBreadcrumbsProps = {
    heading: enqueteCalendarListTitle,
    links: [{ name: 'TOP', href: '/top' }],
    activeLast: true,
  };

  return (
    <PageLayout title={enqueteCalendarListTitle} breadcrumbs={breadcrumbs}>
      <CalendarListPageCommonGrid />
      <CalendarButtonGroup />
      <CalendarListGrid />
    </PageLayout>
  );
};
